import { useGetUserPreferencesQuery } from '@/__generated__/graphql';

/**
 * Custom hook to get user preferences for a given structureId.
 * Returns the userColumns for the Equipment Export table.
 */
export const useUserPreferences = (
  structureId: string,
  columnKey: string,
  parentColumnKey: 'columns' | 'xlsx' = 'columns'
) => {
  const { data: userPreferenceData, refetch } = useGetUserPreferencesQuery({
    fetchPolicy: 'cache-first',
  });

  const preferencesList = userPreferenceData?.getUserPreferences?.structure?.[structureId];
  const userColumns = preferencesList?.[parentColumnKey]?.[columnKey] ?? [];
  return {
    userColumns,
    refetchUserPreferences: refetch,
    preferencesList,
    userPreferenceData,
  };
};
